// Stored CDR call status (report tables + calls table): 'connected' | 'failed' | 'abandoned'.
// Rows stored before the PBX sent callStatus have none — callers pass their old rule as the fallback.
// The only outcomes shown anywhere: Answered | Failed | Abandoned.
export const CALL_STATUS_LABELS: Record<string, string> = {
  connected: 'Answered',
  failed: 'Failed',
  abandoned: 'Abandoned',
};

export const storedCallStatus = (row: any): string | null => {
  const status = String(row?.call_status || '').toLowerCase();
  return CALL_STATUS_LABELS[status] ? status : null;
};

export const isCallConnected = (row: any, fallback: boolean): boolean => {
  const status = storedCallStatus(row);
  return status ? status === 'connected' : fallback;
};

export const callStatusLabel = (row: any, fallbackConnected: boolean): string =>
  CALL_STATUS_LABELS[storedCallStatus(row) || (fallbackConnected ? 'connected' : 'failed')] as string;

export const CALL_OUTCOME_LABELS: Record<string, string> = {
  answered: 'Answered',
  failed: 'Failed',
  abandoned: 'Abandoned',
};
